/* eslint-disable complexity */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CloseButton from "../../shared/icon-cross";
import { GALLERY_TAB_TYPE } from "../car-detail-info/constant";
import styles from "./style.css";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import GreenCheckIcon from "./images/green-check.svg";
import GalleryTabs from "./gallery-tabs";
import GalleryMainSlider from "./gallery-main-slider";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import HelloARView from "../hello-ar-view";
import Button from "../../shared/button";
import IconHeart from "../../shared/icon-heart/component";
import InfoIcon from "./images/infoicon.svg";
import TransparentButton from "../../shared/button/transparent-button";
import { getCarDetailsPageURLWithoutParam } from "../../../utils/helpers/get-detail-page-url";
import { useHistory } from "react-router-dom";
import getCarInfo from "../../../utils/helpers/get-car-info";

const TABS_THREE_SIXTY_FLOW = [
    {
        text: "All Photos",
        type: GALLERY_TAB_TYPE.allImages,
        key: "allImages",
        activeIndex: 0
    },
    {
        text: "Imperfections",
        type: GALLERY_TAB_TYPE.imperfections,
        key: "imperfectionImages",
        activeIndex: 0
    },
    {
        text: "Car Tour",
        type: GALLERY_TAB_TYPE.threeSixtyViewUrl,
        key: "threeSixtyViewUrl",
        activeIndex: 0
    }
];

const TABS_NORMAL_FLOW = [
    {
        text: "Exterior",
        type: GALLERY_TAB_TYPE.exterior,
        key: "exteriorImages",
        activeIndex: 0
    },
    {
        text: "Interior",
        type: GALLERY_TAB_TYPE.interior,
        key: "interiorImages",
        activeIndex: 0
    },
    {
        text: "Imperfections",
        type: GALLERY_TAB_TYPE.imperfections,
        key: "imperfectionImages",
        activeIndex: 0
    }
];

const CarGalleryView = ({
    activeTab,
    content,
    imageHost,
    selectedImageIndex,
    setGsGalleryDataConnect,
    isWishlisted,
    onWishlistClick = () => {},
    comingSoon = false,
    ctaProps = {},
    onClickNotifyIcon
}) => {
    const {  threeSixtyViewUrl } = content || {};
    const [tabs, setTabs] = useState(threeSixtyViewUrl ? TABS_THREE_SIXTY_FLOW : TABS_NORMAL_FLOW);
    const [currentTabIndex, setCurrentTabIndex] = useState(0);
    const {isDealerListing} = getCarInfo(content);
    const history = useHistory();
    useEffect(() => {
        let tabIndex = 0;
        const validTabs = tabs.filter((item, index) => {
            if (item.type === activeTab) {
                tabIndex = index;
                item.activeIndex = selectedImageIndex;
            }
            return !!content[item.key];
        });
        setCurrentTabIndex(tabIndex);
        setTabs(validTabs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, content, selectedImageIndex]);

    const onClose = () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_IMAGE_GALLERY_VIEW_CLOSE);
        const detailPage = getCarDetailsPageURLWithoutParam(content);
        history.push(detailPage);
        setGsGalleryDataConnect({
            isOpen: false
        });
    };

    const getCarousalImages = () => {
        if (isDealerListing) {
            return content?.galleryV2;
        }  else {
            return content && content[tabs[currentTabIndex].key] || [];

        }
    };

    const updateActiveIndex = (idx) => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.SWIPE_IN_GALLERY, {
            eventLabel: idx + 1
        });
        const updatedTabs = [...tabs];
        updatedTabs[currentTabIndex] = { ...updatedTabs[currentTabIndex], activeIndex: idx };
        setTabs(updatedTabs);
    };

    const displayIcon = () => {
        if (!ctaProps.iconType) {
            return (null);
        } else if (ctaProps.iconType === "Info") {
            return (
                <div
                    styleName={"styles.infoicon"}>
                    <img src={InfoIcon} alt={InfoIcon} onClick={onClickNotifyIcon}/>
                </div>);
        } else {
            return (<div
                styleName={"styles.wishlistBtn"}>
                <IconHeart
                    active={isWishlisted}
                    onClick={(e) => onWishlistClick(e, "car_gallery_view")}
                    source="wishlist"
                />
            </div>);
        }
    };

    const carousalImages = !threeSixtyViewUrl ? getCarousalImages() : [];
    const mainImage = carousalImages.length ? carousalImages[tabs[currentTabIndex].activeIndex] : {};
    const hasMainImage = mainImage && mainImage.path ? true : false;

    return (
        <div styleName="styles.spinCar">
            {isDealerListing || (activeTab === GALLERY_TAB_TYPE.threeSixtyViewUrl && threeSixtyViewUrl) ?
                <React.Fragment>
                    <HelloARView
                        content={content}
                        iframeUrl={threeSixtyViewUrl}
                        onClose={onClose}
                        onWishlistClick={onWishlistClick}
                        isWishlisted={isWishlisted}
                        ctaProps={ctaProps}
                        comingSoon={comingSoon}
                    />
                </React.Fragment> :
                <React.Fragment>
                    <div styleName="styles.spinCarTabs">
                        <div styleName={"styles.close"}>
                            <CloseButton type="grey" onClickHandler={onClose} />
                        </div>
                        <GalleryTabs
                            setCurrentTabIndex={setCurrentTabIndex}
                            setGsGalleryDataConnect={setGsGalleryDataConnect}
                            tabs={tabs}
                            activeTab={activeTab}
                        />
                    </div>
                    <div styleName={"styles.gsThreeSixty"}>
                        {Array.isArray(carousalImages) && carousalImages.length && <GalleryMainSlider
                            carousalImages={carousalImages}
                            updateActiveIndex={updateActiveIndex}
                            currentTabIndex={currentTabIndex}
                            tabs={tabs}
                            imageHost={imageHost}
                            content={content}
                        />}
                        {activeTab === GALLERY_TAB_TYPE.imperfections && !hasMainImage && (
                            <div styleName={"styles.noImperfectionsTab"}>
                                <img src={GreenCheckIcon} alt="No Imperfections" />
                                <p styleName={"styles.noImperfectionsText"}>
                                    <strong>No Imperfections</strong>
                                    At Cars24 we pride ourselves on having high refurbishment standards.<br />This car has been thoroughly inspected and refurbished but may have some small remaining areas of wear and tear.
                                </p>
                            </div>
                        )}

                        {/* <div styleName>
                            { (carousalImages || []).length ? <GsGalleryImageCarousel
                                images={carousalImages}
                                baseUrl={imageHost}
                                selectedImageIndex={(tabs[currentTabIndex] && tabs[currentTabIndex].activeIndex) || 0}
                                onImageClick={updateActiveIndex}
                            /> : null}
                        </div> */}
                        <div
                            styleName={"styles.buttonWrap"}>
                            {displayIcon()}
                            {ctaProps.transparentButton ?
                                <div styleName={"styles.transparentBtns"}>
                                    <TransparentButton
                                        text={ctaProps.text}
                                        disabled={ctaProps.disabled}
                                        isLoading={ctaProps.isLoading}
                                        onClick={(e) => ctaProps.action(AU_DESKTOP_EVENTS.CAR_GALLERY_VIEW, e)} /> </div> :
                                <Button
                                    text={ctaProps.text}
                                    disabled={ctaProps.disabled}
                                    isLoading={ctaProps.isLoading}
                                    onClick={(e) => ctaProps.action(AU_DESKTOP_EVENTS.CAR_GALLERY_VIEW, e)}
                                />}
                        </div>
                    </div>
                </React.Fragment>
            }
        </div>
    );
};

CarGalleryView.propTypes = {
    activeTab: PropTypes.string,
    setGsGalleryDataConnect: PropTypes.func,
    content: PropTypes.object,
    imageHost: PropTypes.string,
    selectedImageIndex: PropTypes.number,
    onChangeIndexCallback: PropTypes.func,
    onClickImage: PropTypes.func,
    comingSoon: PropTypes.bool,
    ctaProps: PropTypes.object,
    isWishlisted: PropTypes.bool,
    onWishlistClick: PropTypes.func,
    onClickNotifyIcon: PropTypes.func
};

export default CarGalleryView;
